import { Component, ElementRef, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { BodyUsedClient, CategoryClient, CheckIsCodeExistsRequest, DanhMucQuocGiaClient, GetListProductResponse, ImageEnum, ManufacturerClient, PositionClient, ProductClient, ProductDto, ProductEnum, ProductRequest, ProductUnitClient } from 'src/app/shared/api-connector/sso-connector';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { AutocompleteCacheService } from 'src/app/shared/services/autocomplete-cache.service';
import { AddBodyUsedDialogComponent } from '../add-body-used-dialog/add-body-used-dialog.component';
import { AddProductUnitDialogComponent } from '../add-product-unit-dialog/add-product-unit-dialog.component';
import { AddManufacturerDialogComponent } from '../add-manufacturer-dialog/add-manufacturer-dialog.component';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { AddPositionDialogComponent } from '../add-position-dialog/add-position-dialog.component';
import { AddCategoryDialogComponent } from '../add-category-dialog/add-category-dialog.component';

@Component({
  selector: 'app-edit-thuoc-dialog',
  templateUrl: './edit-thuoc-dialog.component.html',
  styleUrls: ['./edit-thuoc-dialog.component.scss']
})
export class EditThuocDialogComponent implements OnInit {
  lstImage: string[] = [];
  myFormEditProduct = new FormGroup({
    codeCtrl: new FormControl('', {
      updateOn: 'change',
      asyncValidators: [this.validateCodeNotTaken.bind(this)],
    }),
    barcodeCtrl: new FormControl('', {
      updateOn: 'change',
      asyncValidators: [this.validateBarCodeNotTaken.bind(this)],
    }),
    titleCtrl: new FormControl('', {
      validators: [Validators.required],
      updateOn: 'change',
      asyncValidators: [this.validateTitleNotTaken.bind(this)],
    }),
    abbreviationsCtrl: new FormControl('', {
      updateOn: 'change',
      asyncValidators: [this.validateAbbreviationsNotTaken.bind(this)],
    }),
    categoryCtrl: new FormControl('', [Validators.required]),
    bodyUsedCtrl: new FormControl(''),
    positionCtrl: new FormControl(''),
    priceCtrl: new FormControl(0, [
      Validators.required,
      Validators.min(1),
    ]),
    priceCostCtrl: new FormControl(0, [
      Validators.required,
      Validators.min(1),
    ]),
    weightCtrl: new FormControl(0),
    isHomepageCtrl: new FormControl(true),
    inventoryMaxCtrl: new FormControl(999999999),
    inventoryMinCtrl: new FormControl(0),
    descriptionCtrl: new FormControl(''),
    noteOrderCtrl: new FormControl(''),
    registrationNumberCtrl: new FormControl('', {
      updateOn: 'change',
      asyncValidators: [this.validateRegistrationNumberNotTaken.bind(this)],
    }),
    hoatChatCtrl: new FormControl(''),
    hamLuongCtrl: new FormControl(''),
    packingCtrl: new FormControl(''),
    manufacturerCtrl: new FormControl(''),
    quocGiaCtrl: new FormControl(''),
    productUnitCtrl: new FormControl(''),
    hangHoaThanhPhanCtrl: new FormControl(''),
    inventoryCtrl: new FormControl(''),
  });
  ctrls = this.myFormEditProduct.controls;
  isBatchExpireControl = false;

  reloadCategoryComponent = null;
  reloadBodyUsedComponent = null;
  reloadPositionComponent = null;
  reloadProductUnitComponent = null;
  reloadManufacturerComponent = null;
  scrollStrategy: ScrollStrategy;
  dataBinding: GetListProductResponse;
  totalFile = 0;
  isLoadingAvatar: boolean;
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<EditThuocDialogComponent>,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: GetListProductResponse,
    private productClient: ProductClient,
    private danhMucQuocGiaClient: DanhMucQuocGiaClient,
    private manufacturerClient: ManufacturerClient,
    private bodyUsedClient: BodyUsedClient,
    private categoryClient: CategoryClient,
    private productUnitClient: ProductUnitClient,
    private uploadService: UploadService,
    private dialog: MatDialog,
    private readonly scrollStrategyOptions: ScrollStrategyOptions,
    private positionClient: PositionClient,
    private el: ElementRef,
    private autocompleteCache: AutocompleteCacheService,
  ) {
    this.setForm();
    console.log("this.data", this.data);
  }

  ngOnInit(): void {
    this.scrollStrategy = this.scrollStrategyOptions.noop();
  }

  close() {
    this.dialogRef.close();
  }


  handleChange() {
    if (this.isBatchExpireControl) {
      this.ctrls.hangHoaThanhPhanCtrl.setValue('');
    }
  }

  setForm() {
    this.ctrls.codeCtrl.setValue(this.data.code);
    this.ctrls.barcodeCtrl.setValue(this.data.barcode);

    this.ctrls.titleCtrl.setValue(new ProductDto({
      id: this.data.id,
      abbreviations: this.data.abbreviations,
      barcode: this.data.barcode,
      bodyUsedId: this.data.bodyUsedId,
      bodyUsedString: this.data.bodyUsedString,
      categoryId: this.data.categoryId,
      categoryString: this.data.categoryString,
      code: this.data.code,
      description: this.data.description,
      hamLuong: this.data.hamLuong,
      hoatChat: this.data.hoatChat,
      inventoryMax: this.data.inventoryMax,
      inventoryMin: this.data.inventoryMin,
      inventory: this.data.inventory,
      isHomepage: this.data.isHomepage,
      productUnitId: this.data.productUnitId,
      productUnitName: this.data.productUnitName,
      manufacturerId: this.data.manufacturerId,
      manufacturerString: this.data.manufacturerString,
      noteOrder: this.data.noteOrder,
      packing: this.data.packing,
      positionId: this.data.positionId,
      positionString: this.data.positionString,
      priceCost: this.data.priceCost,
      price: this.data.price,
      quocGiaId: this.data.quocGiaId,
      quocGiaString: this.data.quocGiaString,
      registrationNumber: this.data.registrationNumber,
      title: this.data.title,
      weight: this.data.weight,
      type: this.data.type,
      typeString: this.data.typeString,
      inventoryQuantity: this.data.inventoryQuantity,
      orderQuantity: this.data.orderQuantity,
      outOfStockDays: this.data.outOfStockDays,
      status: this.data.status,
      statusString: this.data.statusString,
      note: this.data.note,
      quantity: this.data.quantity,
      discount: this.data.discount,
      discountType: this.data.discountType,
      orderTotal: this.data.orderTotal,
      discountTypeActive: this.data.discountTypeActive,
      fileId: '',
      qtyOrder: 0,
      qtyPurchaseOrder: 0,
      isOverInventory: false
    }));
    this.ctrls.abbreviationsCtrl.setValue(this.data.abbreviations);
    this.ctrls.positionCtrl.setValue(this.data.positionId);
    this.ctrls.priceCtrl.setValue(this.data.price);
    this.ctrls.priceCostCtrl.setValue(this.data.priceCost);
    this.ctrls.weightCtrl.setValue(this.data.weight);
    this.ctrls.isHomepageCtrl.setValue(this.data.isHomepage);
    this.ctrls.inventoryMaxCtrl.setValue(this.data.inventoryMax);
    this.ctrls.inventoryMinCtrl.setValue(this.data.inventoryMin);
    this.ctrls.descriptionCtrl.setValue(this.data.description);
    this.ctrls.noteOrderCtrl.setValue(this.data.noteOrder);
    this.ctrls.registrationNumberCtrl.setValue(this.data.registrationNumber);
    this.ctrls.hoatChatCtrl.setValue(this.data.hoatChat);
    this.ctrls.hamLuongCtrl.setValue(this.data.hamLuong);
    this.ctrls.packingCtrl.setValue(this.data.packing);
    this.ctrls.manufacturerCtrl.setValue(this.data.manufacturerId);
    this.ctrls.inventoryCtrl.setValue(this.data.inventory);
    if (this.data.categoryId) {
      this.categoryClient.getDetail(this.data.categoryId).subscribe(x => {
        this.ctrls.categoryCtrl.setValue(x);
      });
    }
    if (this.data.bodyUsedId) {
      this.bodyUsedClient.getDetail(this.data.bodyUsedId).subscribe(x => {
        this.ctrls.bodyUsedCtrl.setValue(x);
      });
    }

    if (this.data.manufacturerId) {
      this.manufacturerClient.getDetail(this.data.manufacturerId).subscribe(x => {
        this.ctrls.manufacturerCtrl.setValue(x);
      });
    }
    if (this.data.quocGiaId) {
      this.danhMucQuocGiaClient.getDetail(this.data.quocGiaId).subscribe(x => {
        this.ctrls.quocGiaCtrl.setValue(x);
      });
    }

    if (this.data.productUnitId) {
      this.productUnitClient.getDetail(this.data.productUnitId).subscribe(x => {
        this.ctrls.productUnitCtrl.setValue(x);
      });
    }

    if (this.data.positionId) {
      this.positionClient.getDetail(this.data.positionId).subscribe(x => {
        this.ctrls.positionCtrl.setValue(x);
      });
    }

    this.lstImage = this.data.files;
  }

  onfocusInvalid() {
    for (const key of Object.keys(this.myFormEditProduct.controls)) {
      if (this.myFormEditProduct.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
        invalidControl.focus();
        break;
      }
    }
  }

  onSubmit() {
    this.myFormEditProduct.markAllAsTouched();
    this.onfocusInvalid();
    if (this.myFormEditProduct.valid) {
      this.spinner.show();
      this.productClient.createOrUpdate(new ProductRequest({
        id: this.data.id,
        abbreviations: this.ctrls.abbreviationsCtrl.value,
        barcode: this.ctrls.barcodeCtrl.value,
        bodyUsedId: this.ctrls.bodyUsedCtrl.value ? this.ctrls.bodyUsedCtrl.value.id : null,
        categoryId: this.ctrls.categoryCtrl.value ? this.ctrls.categoryCtrl.value.id : null,
        code: this.ctrls.codeCtrl.value,
        description: this.ctrls.descriptionCtrl.value,
        hamLuong: this.ctrls.hamLuongCtrl.value,
        hoatChat: this.ctrls.hoatChatCtrl.value,
        inventoryMax: this.ctrls.inventoryMaxCtrl.value,
        inventoryMin: this.ctrls.inventoryMinCtrl.value,
        isHomepage: this.ctrls.isHomepageCtrl.value,
        manufacturerId: this.ctrls.manufacturerCtrl.value ? this.ctrls.manufacturerCtrl.value.id : null,
        noteOrder: this.ctrls.noteOrderCtrl.value,
        packing: this.ctrls.packingCtrl.value,
        positionId: this.ctrls.positionCtrl.value ? this.ctrls.positionCtrl.value.id : null,
        quocGiaId: this.ctrls.quocGiaCtrl.value ? this.ctrls.quocGiaCtrl.value.id : null,
        registrationNumber: this.ctrls.registrationNumberCtrl.value,
        title: this.ctrls.titleCtrl.value?.title || this.ctrls.titleCtrl.value,
        weight: this.ctrls.weightCtrl.value,
        price: this.ctrls.priceCtrl.value,
        priceCost: this.ctrls.priceCostCtrl.value,
        lstImage: this.lstImage,
        productUnitId: this.ctrls.productUnitCtrl.value ? this.ctrls.productUnitCtrl.value.id : null,
        type: this.data.type,
        inventory: this.ctrls.inventoryCtrl.value,
        lstPrice: this.data.lstPrice
      }))
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe(x => {
          this.alertService.success('Sửa sản phẩm thành công', 'Thành công');
          this.autocompleteCache.clearType('product_');
          this.dialogRef.close(true);
        });
    }
  }

  getUrlFile(id: string) {
    return this.uploadService.getUrlFile(id);
  }

  removeImage(imageId) {
    this.lstImage = this.lstImage.filter(x => x != imageId);
    this.totalFile = this.lstImage.length;
  }

  validateCodeNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsCodeExists(new CheckIsCodeExistsRequest({
        code: control.value,
        oldCode: this.data.code
      })).pipe(
        map(res => {
          return res ? { codeTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  validateBarCodeNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsBarCodeExists(new CheckIsCodeExistsRequest({
        code: control.value,
        oldCode: this.data.barcode
      })).pipe(
        map(res => {
          return res ? { barcodeTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  validateTitleNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsTitleExists(new CheckIsCodeExistsRequest({
        code: control.value?.title || control.value,
        oldCode: this.data.title
      })).pipe(
        map(res => {
          return res ? { titleTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  validateAbbreviationsNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsAbbreviationsExists(new CheckIsCodeExistsRequest({
        code: control.value,
        oldCode: this.data.abbreviations
      })).pipe(
        map(res => {
          return res ? { abbreviationsTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  validateRegistrationNumberNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsRegistrationNumberExists(new CheckIsCodeExistsRequest({
        code: control.value,
        oldCode: this.data.registrationNumber
      })).pipe(
        map(res => {
          return res ? { registrationNumberTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }


  addManufacturer() {
    const dialogRef = this.dialog.open(AddManufacturerDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadManufacturerComponent = x;
      }
    });
  }

  addProductUnit() {
    const dialogRef = this.dialog.open(AddProductUnitDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadProductUnitComponent = x;
      }
    });
  }

  addBodyUsed() {
    const dialogRef = this.dialog.open(AddBodyUsedDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadBodyUsedComponent = x;
      }
    });
  }

  addPosition() {
    const dialogRef = this.dialog.open(AddPositionDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadPositionComponent = x;
      }
    });
  }

  addCategoryDialog() {
    const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadCategoryComponent = x;
      }
    });
  }

  onMultipeFileChange(event) {
    var filesAmount = event.target.files.length;
    if (filesAmount > 5) {
      this.alertService.error("Không vượt quá 5 file", "Lỗi upload file");
      return;
    }
    this.totalFile = filesAmount;
    this.lstImage = [];
    if (filesAmount === 0) {
      return;
    }
    if (event.target.files && event.target.files[0]) {
      this.uploadService
        .uploadMultipeFile(event.target.files, 0, ImageEnum.None)
        .pipe(finalize(() => (this.isLoadingAvatar = false)))
        .subscribe((x: any) => {
          x.forEach((element) => {
            this.lstImage.push(element.Id);
          });
        });
    }
  }
}
